import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SetupItem as SetupItemType, getSetupIcon } from './setup-config';

interface SetupItemProps {
  item: SetupItemType;
  isLast: boolean;
}

export const SetupItem: React.FC<SetupItemProps> = ({ item, isLast }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const IconComponent = getSetupIcon(item.iconType);

  const handleClick = () => {
    navigate(item.route);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate(item.route);
    }
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={t(item.titleKey)}
      className={`
        flex items-center gap-4 pr-2 cursor-pointer
        transition-colors duration-200
        hover:bg-gray-50 dark:hover:bg-gray-800/50
        focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
        dark:focus:ring-offset-gray-900
        dark:bg-[#1F2937]
        rounded-2xl
        ${!isLast ? 'border-b border-gray-200 dark:border-border-dark' : ''}
      `}
    >
      {/* Icon Container - Left Side */}
      <div className="flex-shrink-0 w-40 h-26 flex items-center justify-center rounded-l-2xl bg-[#D3F5EE] dark:bg-emerald-900/30" >
        <IconComponent className="w-8 h-8 text-primary dark:text-primary-dark " />
      </div>

      {/* Text Content - Right Side */}
      <div className="flex-1 flex flex-col gap-1 ">
        <h3 className="font-nunito font-bold text-lg leading-7 text-gray-900 dark:text-white {
          
        }">
          {t(item.titleKey)}
        </h3>
        <p className="font-nunito text-base leading-6 text-gray-600 dark:text-gray-400">
          {t(item.descriptionKey)}
        </p>
      </div>
    </div>
  );
};
